"use strict";var e=require("../Coerce/enumeration.cjs").enumeration({INFO:0,LOG:1,WARNING:2,ERROR:3});exports.MessageType=e;
//# sourceMappingURL=MessageType.cjs.map
